import React from 'react';
import { Typography } from 'antd';
import { calculateLoadColor } from 'shared/utils/trips/load-color-calculator';

interface VehicleLoadProps {
  loadByWeight: number | undefined;
  loadByLDM: number | undefined;
  status: string;
}

export const VehicleLoad: React.FC<VehicleLoadProps> = ({ loadByWeight, loadByLDM, status }) => {
  const color = calculateLoadColor(loadByWeight, loadByLDM, status);

  return (
    <Typography.Text>
      LDM: <strong style={{ color }}>{loadByLDM || '-'} %</strong> / Weight:{' '}
      <strong style={{ color }}>{loadByWeight || '-'} %</strong>
    </Typography.Text>
  );
};
